var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"alt":"Trombi logo","src":require("../assets/trombi.png"),"width":"200px"}}),_c('HelloWorld',{attrs:{"msg":"Where do you think your going?","sub_msg":"There is absolutely nothing here..."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }